/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';
import { displayErrors, formataMoeda, formataTelefone } from '../../../util/diversos';

export default function PdfOrcamento({ payloadPrint, finishPrintOrcamento }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const id = get(payloadPrint, 'id', 0);
  const idUsuario = get(store.getState().auth.user, 'id', 0);

  function headRows() {
    return [
      { registro: 'Código', descricao: 'Descricao', qtde: 'Qtde', precoFinal: 'Valor UN', totalItem: 'Total' },
    ];
  }

  const [headerTabelaImpressao] = useState(headRows());

  useEffect(() => {
    async function getData(img) {
      // eslint-disable-next-line new-cap
      const doc = new jsPDF();

      try {
        const usuario = await axiosAdmin.get(`/usuario/${idUsuario}`);
        let cnpjEmpresa = usuario.data.listaEmpresas[0].cnpj;
        if (cnpjEmpresa.length === 14) {
          cnpjEmpresa = cnpjEmpresa.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }

        const { data } = await axiosAdmin.get(`/orcamento/${id}`);

        const result = [];

        data.listaOrcamentoItem.forEach(element => {
          data.registro = get(element.produto, 'registro', '');
          data.qtde = element.quantidade;
          let descricao = get(element.produto, 'descricao', '').trim();
          data.descricao = descricao;

          data.precoFinal = formataMoeda(element.precoFinal);
          data.totalItem = formataMoeda(element.totalItem);
          result.push({ ...data });
        });

        // linha em branco
        let dados = {
          registro: '',
          qtde: '',
          descricao: '',
          precoFinal: '',
          totalItem: '',
        };
        result.push({ ...dados });

        let observacao = '';
        if (data.observacao) {
          observacao = data.observacao + '\n';
        }

        dados = {
          registro: 'Obs:',
          qtde: '',
          descricao: observacao,
          precoFinal: ' Total',
          totalItem: formataMoeda(data.valorTotal),
        };

        result.push({ ...dados });

        doc.autoTable({
          styles: { fontSize: 8 },
          margin: { bottom: 160, top: 38, left: 5, right: 5 },
          columnStyles: {
            0: { cellWidth: 15 },
            1: { cellWidth: 100 },
            2: { cellWidth: 15 },
          },
          theme: 'grid',
          head: headerTabelaImpressao,
          body: result,
          showHead: 'firstPage',
          showFoot: 'firstPage',
          didDrawPage: (_dados) => {
            // Header
            doc.rect(5, 5, 200, 30);
            doc.addImage(img, 'JPEG', 9, 8, 25, 25);
            doc.setFontSize(20);
            doc.text('Orçamento: ', 40, 13);
            doc.text(id.toString(), 78, 13);

            doc.setFontSize(10);
            data.nomeOrcamento ? doc.text(data.nomeOrcamento, 40, 19) : '';
            doc.setFontSize(8);
            if (data.cliente) {
              if (data.cliente.cnpj && data.cliente.cnpj.length === 14) {
                doc.text('CNPJ: ', 40, 22);
                doc.text(data.cliente.cnpj, 50, 22);
              }
            }

            doc.text('Cliente: ', 40, 25);
            let cliente = '';
            if (data.cliente) {
              cliente = `${data.cliente.id} - ${data.cliente.razaoSocial.substring(0, 45)}`;
            }
            doc.text(cliente, 50, 25);
            doc.text('Telefone: ', 40, 29);
            data.cliente && data.cliente.telefone_1 ? doc.text(formataTelefone(data.cliente.telefone_1), 54, 29) : '';

            doc.setFontSize(8);
            usuario.data.listaEmpresas[0].nomeFantasia ? doc.text(usuario.data.listaEmpresas[0].nomeFantasia, 135, 8) : '';
            cnpjEmpresa ? doc.text(`CNPJ: ${cnpjEmpresa}`, 135, 12) : '';
            usuario.data.email ? doc.text(usuario.data.email, 135, 16) : '';
            if (usuario.data.listaEmpresas[0].endereco && usuario.data.listaEmpresas[0].enderecoNumero) {
              const endereco = `${usuario.data.listaEmpresas[0].endereco} - ${usuario.data.listaEmpresas[0].enderecoNumero}`;
              doc.text(endereco, 135, 20);
            }
            usuario.data.listaEmpresas[0].uf ? doc.text(usuario.data.listaEmpresas[0].uf, 135, 24) : '';
            usuario.data.listaEmpresas[0].cidade ? doc.text(usuario.data.listaEmpresas[0].cidade, 142, 24) : '';
            usuario.data.listaEmpresas[0].telefone_1 ? doc.text(usuario.data.listaEmpresas[0].telefone_1, 135, 28) : '';
            usuario.data.listaEmpresas[0].telefone_2 ? doc.text(usuario.data.listaEmpresas[0].telefone_2, 160, 28) : '';

            doc.setFontSize(8);
            doc.text('Data:', 135, 33);
            doc.setFontSize(10);
            doc.text(new Date(data.data[0], data.data[1] - 1, data.data[2]).toLocaleDateString('pt-br'), 144, 33);
            if (data.dataValidade !== null) {
              doc.setFontSize(8);
              doc.text('Validade:', 170, 33);
              doc.setFontSize(10);
              data.dataValidade ? doc.text(new Date(data.dataValidade[0], data.dataValidade[1] - 1, data.dataValidade[2]).toLocaleDateString('pt-br'), 185, 33) : '';
            } else {
              doc.setFontSize(8);
              doc.text('Validade:', 170, 33);
              doc.setFontSize(10);
              doc.text('30 dias', 185, 33);
            }

            // footer
            const { pageSize } = doc.internal;
            const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(`Pag ${doc.internal.getNumberOfPages()}`, _dados.settings.margin.right, 144);
            doc.text('Elo Informática Barbacena LTDA', 82, 144);
            const periodo = new Date();
            doc.text('Impresso: ', 172, 144);
            // eslint-disable-next-line prefer-template
            doc.text((`${('00' + periodo.getDate()).slice(-2)}/${('00' + (+periodo.getMonth() + 1)).slice(-2)}/${periodo.getFullYear()}`).toString(), 189, 144);
          },
        });

        window.open(doc.output('bloburl'));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('erro', err);
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        // funcao no pai pra fechar a tela de impressao
        finishPrintOrcamento();
      }
    }

    const loadImage = async () => {
      let config = '';
      try {
        config = await axiosAdmin.get(`/configuracaosistema?idUsuario=${idUsuario}`);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      }

      const img = new Image();
      img.src = `/logotipos/${config.data.urlLogotipo}`;
      await img.decode().then(() => {

      }).catch(() => {
        img.src = 'logo.png';
      });
      getData(img);
    };
    loadImage();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch, navigate]);

  return (
    <div></div>
  );
}
